<div *ngIf="form">
  <form [formGroup]="form">
    <div class="column">
      <dx-text-box formControlName="name" formField required />

      <dx-select-box
        formControlName="batchTraceability"
        formField
        required
        [items]="batchTraceabilityItems"
        displayExpr="name"
        valueExpr="code"
        [acceptCustomValue]="true"
        (valueChange)="updateTraceabilityDependentValidators($event)"
      />

      <dx-select-box
        *ngIf="isBatch || isSerialNumber"
        formControlName="batchCodeDefinition"
        formField
        required
        [items]="batchCodeDefinitions"
        displayExpr="name"
        valueExpr="code"
        [acceptCustomValue]="true"
        (valueChange)="updateCodeDefinitionDependentFields($event)"
      />
      @if((isBatch || isSerialNumber) && isSequentialCode){
        <dx-text-box
          formControlName="batchCodeRangeMin"
          formField
          required
          [placeholder]="'entity.batchType.batchCodeRangeMin' | translate | ucfirst"
        />
        <dx-text-box
          formControlName="batchCodeRangeMax"
          formField
          required
          [placeholder]="'entity.batchType.batchCodeRangeMax' | translate | ucfirst"
        />
        <dx-switch formControlName="batchCodeUseEan13" formField />
      }
      <dx-select-box
        *ngIf="isBatch || isSerialNumber"
        formControlName="providerBatchCodeDefinition"
        formField
        required
        [items]="providerBatchCodeDefinitions"
        displayExpr="name"
        valueExpr="code"
        [acceptCustomValue]="true"
        (valueChange)="updateProviderCodeDefinitionDependentFields($event)"
      />
      @if((isBatch || isSerialNumber) && isSequentialProviderCode){
        <dx-text-box
          formControlName="providerBatchCodeRangeMin"
          formField
          required
          [placeholder]="'entity.batchType.providerBatchCodeRangeMin' | translate | ucfirst"
        />
        <dx-text-box
          formControlName="providerBatchCodeRangeMax"
          formField
          required
          [placeholder]="'entity.batchType.providerBatchCodeRangeMax' | translate | ucfirst"
        />
        <dx-switch formControlName="providerBatchCodeUseEan13" formField />
      }
      <dx-select-box
        *ngIf="isBatch|| isSerialNumber"
        formControlName="batchSelectionCriteria"
        formField
        required
        [items]="batchSelectionCriteriaItems"
        displayExpr="name"
        valueExpr="code"
        [acceptCustomValue]="true"
      />

      <dx-select-box
        *ngIf="isBatch || isSerialNumber"
        formControlName="batchSplittingMode"
        formField
        [items]="batchSplittingModeItems"
        displayExpr="name"
        valueExpr="code"
        [acceptCustomValue]="true"
      />
      <dx-lookup
        [gsResource]="productBatchStates"
        formControlName="defaultBatchStateId"
        displayExpr="name"
        valueExpr="id"
        formField
        required
        [placeholder]="'entity.batchType.defaultBatchStateId' | translate | ucfirst"
      />
    </div>
  </form>
</div>
